var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InformationModal,{attrs:{"visible":_setup.isLoginAlertVisibleInStore,"modal-title":_setup.title,"message":_setup.message,"ok-text":"I understand","information-type":"warning","closable":false},on:{"confirm":_setup.closeLoginAlert}})
}
var staticRenderFns = []

export { render, staticRenderFns }